import type { ThemeConfig } from 'antd';

/** Echo's indigo (Docs/brand/README.md) on top of antd's defaults. */
export const BRAND = {
  body: '#5B50E8',
  wings: '#3B31B5',
  face: '#EEF0FF',
  ear: '#F9A8D4',
  ping: '#22D3EE',
  ink: '#1E1B4B',
} as const;

export const adminTheme: ThemeConfig = {
  token: {
    colorPrimary: BRAND.body,
    borderRadius: 8,
    colorTextDescription: '#5b6472',
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    Layout: {
      siderBg: BRAND.ink,
      headerBg: '#ffffff',
      bodyBg: '#f5f6fb',
    },
    Menu: {
      darkItemBg: BRAND.ink,
      darkSubMenuItemBg: BRAND.ink,
      darkItemSelectedBg: BRAND.wings,
      darkItemColor: 'rgba(238,240,255,0.85)',
    },
  },
};
